const Sentry = () => import(/* webpackChunkName: "sentry" */ 'lib/sentry');

const logger = {
  log(error) {
    Sentry().then(sentry => {
      sentry.default.log(error);
    });
  },
};

export default logger;
